import DOMPurify from 'dompurify';

/**
 * Sanitize HTML code before rendering
 * Allows style tags and specific attributes for visual editing
 */
export const sanitizeHtml = (htmlCode) => {
    return DOMPurify.sanitize(htmlCode, {
        ADD_TAGS: ['style', 'img', 'input', 'button', 'iframe', 'svg', 'path'],
        ADD_ATTR: [
            'class',
            'style',
            'src',
            'placeholder',
            'type',
            'frameborder',
            'allow',
            'autoplay',
            'id',
            'data-element-id',
            'draggable',
            'viewBox',
            'd',
            'fill',
            'stroke',
            'stroke-width'
        ],
        ALLOW_DATA_ATTR: true,
        KEEP_CONTENT: true
    });
};

/**
 * Convert RGB color to HEX format
 */
export const rgbToHex = (rgb) => {
    if (!rgb || rgb === 'rgba(0, 0, 0, 0)' || rgb === 'transparent') {
        return '#ffffff';
    }
    if (rgb.startsWith('#')) {
        return rgb;
    }

    const sep = rgb.indexOf(',') > -1 ? ',' : ' ';
    const rgbArr = rgb.substr(4).split(')')[0].split(sep);

    let r = (+rgbArr[0]).toString(16);
    let g = (+rgbArr[1]).toString(16);
    let b = (+rgbArr[2]).toString(16);

    if (r.length === 1) r = '0' + r;
    if (g.length === 1) g = '0' + g;
    if (b.length === 1) b = '0' + b;

    return '#' + r + g + b;
};
